import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureRemixErrorBoundaryError } from '@sentry/remix';

import { type TextBlockIndexProps, TextBlockWithQuery } from '@cx-modules/text-block';

export const TextBlock = (props: Omit<TextBlockIndexProps, 'i18n'>) => {
  const { i18n } = useTranslation();
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureRemixErrorBoundaryError(error);
        return null;
      }}
    >
      <TextBlockWithQuery {...props} i18n={i18n} />
    </ErrorBoundary>
  );
};
